<template>
  <ModuleWrapper
    :moduleId="moduleId"
    :image="imageSrcPath('assets/branding/button-card-color.svg')"
    title="Agenda Tile Background Shade"
    @initializeData="initializeData"
  >
    <template #main>
      <StudioSelect
        id="agenda-tile-background-select"
        label="Shade Type"
        :options="[
          { value: 'light', label: 'Light' },
          { value: 'dark', label: 'Dark' }
        ]"
        size="small"
        orientation="horizontal"
        :value="selectedSidebarColorType"
        @change="e => onSelectOverlayType(e.target.value)"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';

import { StudioSelect } from '@/studioComponents';

export default {
  name: 'TileBackground',
  components: {
    ModuleWrapper,
    StudioSelect
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedSidebarColorType: 'dark'
    };
  },
  created() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    })
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInThemeObj: 'setChangesMadeInThemeObj'
    }),
    initializeData() {
      const moduleKeys = ['splash_background_shade', 'splash_shade_alpha'];
      const { splash_background_shade: splashBackgroundShade } = this.getInitialModuleData(moduleKeys);
      if (splashBackgroundShade) {
        this.selectedSidebarColorType = splashBackgroundShade === '255, 255, 255' ? 'light' : 'dark';
      }
    },
    onSelectOverlayType(selectedType) {
      this.selectedSidebarColorType = selectedType;
      this.setChangesMadeInThemeObj({
        splash_background_shade: selectedType === 'dark' ? '0, 0, 0' : '255, 255, 255'
      });
    }
  }
};
</script>
